import React from 'react';

const Sailplanes = () => {
    return (
        <div className='App'>Sailplanes</div>
    );
}

export default Sailplanes;